/**
 * @generated SignedSource<<d224675863891eeba9a40481cd1f743a>>
 * @relayHash 372309b5af361702a415d9ff50752ae5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 35bcf148e31afa9cf811a83067a0edd47e4529c28aa8636f903711bda4817860

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraBoardSwimlaneStrategy = "ASSIGNEE_UNASSIGNED_FIRST" | "ASSIGNEE_UNASSIGNED_LAST" | "CUSTOM" | "EPIC" | "ISSUE_CHILDREN" | "ISSUE_PARENT" | "NONE" | "PARENT_CHILD" | "PROJECT" | "REQUEST_TYPE" | "TOWNSQUARE_PROJECT" | "%future added value";
export type JiraIssueSearchOperationScope = "NIN_GLOBAL" | "NIN_GLOBAL_SCHEMA_REFACTOR" | "NIN_GLOBAL_SHADOW_REQUEST" | "NIN_PROJECT" | "NIN_PROJECT_SCHEMA_REFACTOR" | "NIN_PROJECT_SHADOW_REQUEST" | "TIMELINE_BOARD" | "TIMELINE_PROJECT" | "%future added value";
export type JiraJqlViewContext = "JPD_ROADMAPS" | "JSM_QUEUE_PAGE" | "JSM_SUMMARY_PAGE" | "JSW_PLANS" | "JSW_SUMMARY_PAGE" | "JWM" | "SHADOW_REQUEST" | "%future added value";
export type JiraHydrateJqlInput = {
  filterId?: string | null;
  jiraViewQueryInput?: JiraViewQueryInput | null;
  jql?: string | null;
  lastUsedJqlForIssueNavigator?: JiraJqlScopeInput | null;
  viewQueryInput?: JiraIssueSearchViewQueryInput | null;
};
export type JiraViewQueryInput = {
  boardIdAndItemQuery?: JiraViewBoardIdAndItemQuery | null;
  projectKeyAndItemQuery?: JiraViewProjectKeyAndItemQuery | null;
  subcontainerIdAndItemQuery?: JiraViewSubcontainerIdAndItemQuery | null;
  viewId?: string | null;
};
export type JiraViewBoardIdAndItemQuery = {
  boardId: AGG$Long;
  cloudId: string;
  itemId: string;
};
export type JiraViewProjectKeyAndItemQuery = {
  cloudId: string;
  itemId: string;
  projectKey: string;
};
export type JiraViewSubcontainerIdAndItemQuery = {
  cloudId: string;
  itemId: string;
  subcontainerId: string;
};
export type JiraJqlScopeInput = {
  agentSessions?: JiraAgentSessionsScopeInput | null;
  backlog?: JiraJqlBacklogInput | null;
  board?: JiraJqlBoardInput | null;
  list?: JiraIssueSearchScope | null;
  plan?: JiraJqlPlanInput | null;
  project?: JiraJqlProjectInput | null;
};
export type JiraAgentSessionsScopeInput = {
  boardId?: string | null;
  jql?: string | null;
  spaceKey?: string | null;
};
export type JiraJqlBacklogInput = {
  boardId: AGG$Long;
};
export type JiraJqlBoardInput = {
  boardId: AGG$Long;
  swimlaneStrategy?: JiraBoardSwimlaneStrategy | null;
};
export type JiraIssueSearchScope = {
  operationScope?: JiraIssueSearchOperationScope | null;
  projectKey?: string | null;
};
export type JiraJqlPlanInput = {
  planId: AGG$Long;
  scenarioId?: AGG$Long | null;
};
export type JiraJqlProjectInput = {
  projectKey?: string | null;
};
export type JiraIssueSearchViewQueryInput = {
  projectKeyAndItemIdQuery?: JiraIssueSearchViewProjectKeyAndItemIdQuery | null;
  viewAri?: string | null;
};
export type JiraIssueSearchViewProjectKeyAndItemIdQuery = {
  cloudId: string;
  itemId: string;
  projectKey: string;
};
export type useHydrationQueryLoaderQuery$variables = {
  accountId: string;
  cloudId: string;
  includeJira: boolean;
  includeUser: boolean;
  input?: JiraHydrateJqlInput | null;
  scope?: JiraJqlScopeInput | null;
  viewContext?: JiraJqlViewContext | null;
};
export type useHydrationQueryLoaderQuery$data = {
  readonly jira?: {
    readonly jqlBuilder: {
      readonly hydrateJqlQuery: {
        readonly __typename: "JiraJqlHydratedQuery";
        readonly jql: string | null;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"JQLBuilderUI" | "JQLEditorUIWithErrorBoundary" | "QuerySupportedContainer" | "useHydratedValues" | "useHydratedValuesUtils">;
};
export type useHydrationQueryLoaderQuery = {
  response: useHydrationQueryLoaderQuery$data;
  variables: useHydrationQueryLoaderQuery$variables;
};
({
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarwithapptypeforjqlrelayprovider": includeAppTypeForJqlBuilder_provider
} as {
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarwithapptypeforjqlrelayprovider: {
    readonly get: () => boolean;
  };
});

import includeAppTypeForJqlBuilder_provider from '@jira/platform__graphql-relay-provider/src/jira-ai-agent-avatar-with-apptype-for-jql.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeJira"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeUser"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scope"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewContext"
},
v7 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v8 = {
  "kind": "Variable",
  "name": "scope",
  "variableName": "scope"
},
v9 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  },
  (v8/*: any*/),
  {
    "kind": "Variable",
    "name": "viewContext",
    "variableName": "viewContext"
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v11 = {
  "kind": "ScalarField",
  "name": "jql"
},
v12 = {
  "kind": "ScalarField",
  "name": "id"
},
v13 = [
  (v10/*: any*/),
  {
    "kind": "ScalarField",
    "name": "picture"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarwithapptypeforjqlrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "appType"
          }
        ]
      }
    ],
    "type": "AppUser"
  },
  (v12/*: any*/)
],
v14 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v15 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v16 = {
  "kind": "ScalarField",
  "name": "key"
},
v17 = [
  {
    "concreteType": "JiraStatusCategory",
    "kind": "LinkedField",
    "name": "statusCategory",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "colorName"
      },
      (v12/*: any*/)
    ]
  }
],
v18 = {
  "kind": "ScalarField",
  "name": "name"
},
v19 = {
  "kind": "ScalarField",
  "name": "optionId"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useHydrationQueryLoaderQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "JQLBuilderUI"
      },
      {
        "kind": "FragmentSpread",
        "name": "useHydratedValues"
      },
      {
        "kind": "FragmentSpread",
        "name": "JQLEditorUIWithErrorBoundary"
      },
      {
        "kind": "FragmentSpread",
        "name": "QuerySupportedContainer"
      },
      {
        "kind": "FragmentSpread",
        "name": "useHydratedValuesUtils"
      },
      {
        "condition": "includeJira",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v7/*: any*/),
                "concreteType": "JiraJqlBuilder",
                "kind": "LinkedField",
                "name": "jqlBuilder",
                "plural": false,
                "selections": [
                  {
                    "args": (v9/*: any*/),
                    "kind": "LinkedField",
                    "name": "hydrateJqlQuery",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v11/*: any*/)
                        ],
                        "type": "JiraJqlHydratedQuery"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarwithapptypeforjqlrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "useHydrationQueryLoaderQuery",
    "selections": [
      {
        "condition": "includeUser",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "accountId",
                "variableName": "accountId"
              }
            ],
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": (v13/*: any*/)
          }
        ]
      },
      {
        "condition": "includeJira",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v7/*: any*/),
                "concreteType": "JiraJqlBuilder",
                "kind": "LinkedField",
                "name": "jqlBuilder",
                "plural": false,
                "selections": [
                  {
                    "args": (v9/*: any*/),
                    "kind": "LinkedField",
                    "name": "hydrateJqlQuery",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v11/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": true,
                            "selections": [
                              (v10/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v14/*: any*/),
                                  {
                                    "concreteType": "JiraJqlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      {
                                        "concreteType": "JiraJqlSearchTemplate",
                                        "kind": "LinkedField",
                                        "name": "searchTemplate",
                                        "plural": false,
                                        "selections": [
                                          (v16/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "shouldShowInContext"
                                      },
                                      {
                                        "args": [
                                          (v8/*: any*/)
                                        ],
                                        "kind": "ScalarField",
                                        "name": "shouldExcludeInScope"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "type"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "description"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "operators"
                                      },
                                      {
                                        "concreteType": "JiraFieldType",
                                        "kind": "LinkedField",
                                        "name": "fieldType",
                                        "plural": false,
                                        "selections": [
                                          (v15/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "name": "values",
                                    "plural": true,
                                    "selections": [
                                      (v10/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v14/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "name": "values",
                                            "plural": true,
                                            "selections": [
                                              (v10/*: any*/),
                                              (v14/*: any*/),
                                              (v15/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                      (v16/*: any*/),
                                                      {
                                                        "concreteType": "JiraAvatar",
                                                        "kind": "LinkedField",
                                                        "name": "avatar",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "small"
                                                          }
                                                        ]
                                                      },
                                                      (v12/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraJqlProjectFieldValue"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": (v17/*: any*/),
                                                "type": "JiraJqlStatusFieldValue"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": (v17/*: any*/),
                                                "type": "JiraJqlStatusCategoryFieldValue"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypes",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraAvatar",
                                                        "kind": "LinkedField",
                                                        "name": "avatar",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "xsmall"
                                                          }
                                                        ]
                                                      },
                                                      (v12/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraJqlIssueTypeFieldValue"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "name": "user",
                                                    "plural": false,
                                                    "selections": (v13/*: any*/)
                                                  }
                                                ],
                                                "type": "JiraJqlUserFieldValue"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraPriority",
                                                    "kind": "LinkedField",
                                                    "name": "priority",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "iconUrl"
                                                      },
                                                      (v12/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraJqlPriorityFieldValue"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "issue",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraIssueFieldConnection",
                                                        "kind": "LinkedField",
                                                        "name": "fields",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v10/*: any*/),
                                                                  {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                      {
                                                                        "kind": "ScalarField",
                                                                        "name": "text"
                                                                      }
                                                                    ],
                                                                    "type": "JiraSingleLineTextField"
                                                                  },
                                                                  (v12/*: any*/)
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      },
                                                      (v12/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraJqlIssueFieldValue"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraSprint",
                                                    "kind": "LinkedField",
                                                    "name": "sprint",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "state"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "boardName"
                                                      },
                                                      (v12/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraJqlSprintFieldValue"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "alias": "townsquareProject",
                                                    "concreteType": "JiraTownsquareProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                      (v18/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "iconName"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "privateProject"
                                                      },
                                                      (v12/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraJqlTownsquareProjectFieldValue"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraGoal",
                                                    "kind": "LinkedField",
                                                    "name": "goal",
                                                    "plural": false,
                                                    "selections": [
                                                      (v18/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "status"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "iconKey"
                                                      },
                                                      (v12/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraJqlGoalsFieldValue"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v19/*: any*/),
                                                  {
                                                    "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                    "kind": "LinkedField",
                                                    "name": "parentOption",
                                                    "plural": false,
                                                    "selections": [
                                                      (v15/*: any*/),
                                                      (v14/*: any*/),
                                                      (v19/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraJqlCascadingOptionFieldValue"
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "JiraJqlQueryHydratedValue"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v14/*: any*/),
                                          {
                                            "concreteType": "QueryError",
                                            "kind": "LinkedField",
                                            "name": "error",
                                            "plural": false,
                                            "selections": [
                                              (v10/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraJqlQueryHydratedError"
                                      }
                                    ]
                                  }
                                ],
                                "type": "JiraJqlQueryHydratedField"
                              }
                            ]
                          }
                        ],
                        "type": "JiraJqlHydratedQuery"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "message"
                          }
                        ],
                        "type": "QueryError"
                      }
                    ]
                  },
                  (v12/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "35bcf148e31afa9cf811a83067a0edd47e4529c28aa8636f903711bda4817860",
    "metadata": {},
    "name": "useHydrationQueryLoaderQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarwithapptypeforjqlrelayprovider": includeAppTypeForJqlBuilder_provider
    }
  }
};
})();

(node as any).hash = "7bcf5c12250bef7d4c73f40eb923e8db";

export default node;
